export const columns = [
  { accessorKey: "roleName", header: "Role Name", flex: 1 },
  {
    accessorKey: "consignmentTypes",
    header: "Consignment",
    type: "string",
    size: 250,
  },
  { accessorKey: "terminalName", header: "Terminal Name", flex: 1 },
  // {
  //   accessorKey: "allowImport",
  //   header: "Import",
  //   type: "boolean",
  //   flex: 1,
  // },
  // {
  //   accessorKey: "allowExport",
  //   header: "Export",
  //   type: "boolean",
  //   flex: 1,
  // },
  {
    accessorKey: "isActive",
    header: "Is Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "action",
    header: "Action",
    type: "string",
    size: 250,
    accessorFn: (row: any) => ` ${row.action || " "}`,
  },
];
